import { render, staticRenderFns } from "./includeDetail.vue?vue&type=template&id=2a6bb19e&scoped=true&"
import script from "./includeDetail.vue?vue&type=script&lang=js&"
export * from "./includeDetail.vue?vue&type=script&lang=js&"
import style0 from "./includeDetail.vue?vue&type=style&index=0&id=2a6bb19e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bb19e",
  null
  
)

export default component.exports